export default __webpack_public_path__ + "static/landing-background-19b503f7208e8ed9ec0cb741ccadac2e.mp4";